import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { DateTime } from 'luxon'

import { Box, Button, Text } from '@campaignhub/suit-theme'

import PageContext from '@contexts/pageContext'
import useCurrentUser from '@hooks/useCurrentUser'
import { getDeadline } from '@functions/getDeadline'
import { getEntityByName } from '@functions/getEntityByName'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBellOn } from '@fortawesome/pro-light-svg-icons'

const ServiceJobDeadlines = (props) => {
  const { showStudioDeadline } = props

  const { serviceJob } = useContext(PageContext)
  const { status } = serviceJob

  const entities = useSelector(reduxState => reduxState.entities)
  const { serviceJobStatuses } = entities

  const { currentUser: { timeZone } } = useCurrentUser()

  const now = DateTime.fromISO(DateTime.now(), { zone: timeZone })
  const clientDeadline = DateTime.fromISO(serviceJob.clientDeadline, { zone: timeZone })
  const studioDeadline = DateTime.fromISO(serviceJob.studioDeadline, { zone: timeZone })
  const proofedAt = DateTime.fromISO(serviceJob.proofedAt, { zone: timeZone })

  const deadlineHoursDiff = now.diff(clientDeadline, ['years', 'months', 'days', 'hours', 'minutes'])
  const proofedHoursDiff = proofedAt.diff(clientDeadline, ['years', 'months', 'days', 'hours', 'minutes'])

  const pastDeadline = now > clientDeadline
  const proofPastDeadline = proofedAt.invalid ? true : proofedAt > clientDeadline

  return (
    <>
      {showStudioDeadline && (
        <Box flexDirection="column" paddingBottom="large">
          <Box flexDirection="row" paddingBottom="small">
            <Text fontSize="small" paddingRight="small">
              Studio Deadline
            </Text>
            <FontAwesomeIcon icon={faBellOn} color="#B62121" />
          </Box>
          <Button backgroundColor="#FA6F6F" color="white" border={0} size="small">
            {`${studioDeadline.toFormat('hh:mm a')}, ${studioDeadline.toFormat('dd LLLL y')}`}
          </Button>
        </Box>
      )}
      <Box flexDirection="column" paddingBottom="large">
        <Box flexDirection="row" paddingBottom="small">
          <Text fontSize="small" paddingRight="small">
            Client Deadline
          </Text>
          <FontAwesomeIcon icon={faBellOn} color="#B62121" />
        </Box>
        {
          !proofedAt.invalid ? (
            <>
              <Button
                backgroundColor="white"
                color={proofPastDeadline ? 'red' : 'green'}
                border={proofPastDeadline ? '1.5px solid red' : '1.5px solid green'}
                size="small"
              >
                {`${clientDeadline.toFormat('hh:mm a')}, ${clientDeadline.toFormat('dd LLLL y')}`}
              </Button>
              <Button
                backgroundColor="white"
                color={proofPastDeadline ? 'red' : 'green'}
                border={proofPastDeadline ? '1.5px solid red' : '1.5px solid green'}
                size="small"
                marginTop="small"
              >
                {!proofPastDeadline ? 'Submitted' : getDeadline(proofedHoursDiff.toObject(), proofPastDeadline, true)}
              </Button>
            </>
          ) : (
            ((serviceJob.service?.onSite && status?.id < getEntityByName(serviceJobStatuses, 'Booked')?.id)
              || (!serviceJob.service?.onSite && status?.id < getEntityByName(serviceJobStatuses, 'Uploaded')?.id))
              && !studioDeadline.invalid && pastDeadline ? (
              <>
                <Button
                  backgroundColor="#282B42"
                  color="white"
                  border={0}
                  size="small"
                >
                  {`${clientDeadline.toFormat('hh:mm a')}, ${clientDeadline.toFormat('dd LLLL y')}`}
                </Button>
              </>
            ) : (
              <>
                <Button
                  backgroundColor={deadlineHoursDiff.toObject().days <= -1 && !pastDeadline ? 'green'
                    : deadlineHoursDiff.toObject().days >= 0 && !pastDeadline ? '#E3B418' : 'red'}
                  color="white"
                  border={0}
                  size="small"
                >
                  {`${clientDeadline.toFormat('hh:mm a')}, ${clientDeadline.toFormat('dd LLLL y')}`}
                </Button>
                <Button
                  backgroundColor={deadlineHoursDiff.toObject().days <= -1 && !pastDeadline ? 'green'
                    : deadlineHoursDiff.toObject().days >= 0 && !pastDeadline ? '#E3B418' : 'red'}
                  color="white"
                  border="0"
                  size="small"
                  marginTop="small"
                >
                  {getDeadline(deadlineHoursDiff.toObject(), pastDeadline)}
                </Button>
              </>
            )
          )
        }
      </Box>
    </>
  )
}

ServiceJobDeadlines.propTypes = {
  showStudioDeadline: PropTypes.bool,
}

export default ServiceJobDeadlines
